/**
 * Created by mark on 10/01/2018.
 */



import React from 'react';
import {Button} from 'react-bootstrap';
import Recorder from '../Recorder.js'
import Config from '../classes/config.js';
import Translation from '../store/internationalization-store.js';


export default class RecorderUpload extends React.Component {

    constructor(props){
        super(props);
        this.props = props;
        this.state = {command:'stop' , recording:false , audioPreview:null,baseFile:props.baseFile }
    }

    componentWillReceiveProps(props){

        if(!props.recorded)
        {
            this.setState({
                audioPreview: props.audioPreview || null,
                baseFile:props.baseFile
            });
        } else {
            this.setState({
                baseFile:props.baseFile
            });
        }

    }

    onStop(blob){

        let reader = new FileReader();
        let file   = blob;

        reader.onloadend = () => {
            this.setState({
                file: file,
                audioPreview: reader.result
            });

            this.props.onChange(reader.result);
        };

        if (file != undefined) {
            reader.readAsDataURL(file)
        }
    }

    onStart(){
        console.log('start')
    }



    handelPreviewPlay(src){
        console.log(src)
        this.audio = new Audio(src);
        this.audio.play();
    }

    toggleRecording(){

        let recording = !this.state.recording;
        this.setState({
            command : recording ? 'start' : 'stop',
            recording : recording
        });
    }

    render(){
        var playButton = "";
        if (!this.state.audioPreview && this.state.baseFile != undefined && this.state.baseFile != "") {
            playButton = <Button width={150} bsSize='small' onClick={function() {
                var audio = new Audio(Config.getBaseUrl()+"feedback/" + this.state.baseFile);
                audio.play();
            }.bind(this)} bsStyle="default" block><i className="zmdi-hc-1x zmdi zmdi-volume-up mdc-text-green"></i>{Translation.get(12648, 'Play Audio Comment')}</Button>
        } else {
            playButton = <Button width={150} bsSize='small' disabled={!this.state.audioPreview} onClick={this.handelPreviewPlay.bind(this , this.state.audioPreview)} bsStyle="default" block><i className="zmdi-hc-1x zmdi zmdi-volume-up mdc-text-green"></i>{Translation.get(12648, 'Play Audio Comment')}</Button>
        }

        return <div>
            {playButton}
            <Button width={150}  bsSize='small'  className={this.state.recording ? "" : "" } onClick={this.toggleRecording.bind(this)} bsStyle={this.state.recording ? "danger" : "default"} block>
                <i className={"fas "+ ( this.state.recording ? "mdc-text-white  fa-stop animated infinite pulse" :"fa-microphone")}></i>&nbsp;{this.state.recording ? Translation.get(12649, 'Stop Recording') : Translation.get(12764, 'Record Audio Comment')}
            </Button>

            <Recorder command={this.state.command} onStart={this.onStart.bind(this)}  onStop={this.onStop.bind(this)} />
        </div>
    }

}